import { WebpBlueGradientSplash } from '@egw/assets'
import { Button, ButtonVariant, HeaderCover } from '@egw/components'
import { configClient } from '@egw/config'
import { type FeatureFlags } from '@egw/constants'
import { useFlags } from '@egw/feature-flags'
import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { useNavigate } from 'react-router'
import { type Config } from '../../../types'

export const InvestmentAccountNotRegistered: FC = () => {
  const { t } = useTranslation('features-investment')
  const { globalEnrollBaseUrl } = configClient.getConfig() as Config
  const { flags } = useFlags<FeatureFlags>()
  const navigate = useNavigate()

  return flags.personalPortfolioMulltiAccountEnrollment ? (
    <>
      <HeaderCover
        category={t('investment.title').toUpperCase()}
        title={t('not_registered.account_name')}
        imgUrl={WebpBlueGradientSplash}
      />
      <div className="egw-container flex flex-col gap-4">
        <h2 className="typo-primary-lg-semibold text-text-body">{t('not_registered.get_started_heading')}</h2>
        <p className="text-text-meta typo-primary-sm">{t('not_registered.get_started_p1_2')}</p>
        <p className="text-text-meta typo-primary-sm">{t('not_registered.get_started_p2_2')}</p>
        <p className="text-text-meta typo-primary-sm-semibold">{t('not_registered.get_started_p3_2')}</p>

        <Button
          onClick={() => void navigate('/enrollment', { replace: true })}
          id="get-started-cta"
          testId="get-started-cta"
          variant={ButtonVariant.Primary}
          className="w-full py-sm md:w-fit"
        >
          {t('not_registered.get_started_cta')}
        </Button>
      </div>
    </>
  ) : (
    <>
      <HeaderCover
        category={t('investment.title').toUpperCase()}
        title={t('not_registered.account_name')}
        imgUrl={WebpBlueGradientSplash}
      />
      <div className="egw-container flex flex-col gap-4">
        <h2 className="typo-primary-lg-semibold text-text-body">{t('not_registered.get_started_heading')}</h2>
        <p className="text-text-meta typo-primary-sm">{t('not_registered.get_started_p1')}</p>
        <p className="text-text-meta typo-primary-sm">{t('not_registered.get_started_p2')}</p>
        <p className="text-text-meta typo-primary-sm-semibold">{t('not_registered.get_started_p3')}</p>

        <Button
          onClick={() => {
            document.location = `${globalEnrollBaseUrl}?egm_exp=personal-portfolio`
          }}
          id="get-started-cta"
          testId="get-started-cta"
          variant={ButtonVariant.Primary}
          className="w-full py-sm md:w-fit"
        >
          {t('not_registered.get_started_cta')}
        </Button>
      </div>
    </>
  )
}
